var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSendReviewers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.43321C5.25197 3.43321 2.30648 5.21024 0.133016 8.0966C-0.0443388 8.33308 -0.0443388 8.66345 0.133016 8.89992C2.30648 11.7898 5.25197 13.5668 8.5 13.5668C11.748 13.5668 14.6935 11.7898 16.867 8.9034C17.0443 8.66692 17.0443 8.33656 16.867 8.10008C14.6935 5.21024 11.748 3.43321 8.5 3.43321ZM8.733 12.068C6.57691 12.2036 4.79641 10.4266 4.93203 8.267C5.04332 6.4865 6.4865 5.04332 8.267 4.93204C10.4231 4.79641 12.2036 6.57344 12.068 8.733C11.9532 10.51 10.51 11.9532 8.733 12.068ZM8.62519 10.4196C7.46369 10.4926 6.50389 9.53631 6.58039 8.37481C6.63951 7.41501 7.41848 6.63951 8.37829 6.57692C9.53979 6.50389 10.4996 7.46021 10.4231 8.62172C10.3605 9.585 9.58152 10.3605 8.62519 10.4196Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSendReviewers);
export default __webpack_public_path__ + "static/media/NoSendReviewers.b3ae90a2.svg";
export { ForwardRef as ReactComponent };